export enum DateTimeDisplayStyle {
    Default = 0,            // same as ShortDate
    ShortDate = 1,          //  'dd mmm yyyy'
    LongDate = 2,           //  'Monday, June 15, 2009'
    ShortTime = 3,          //  '1:45 PM'
    LongTime = 4,           //  '1:45:30 PM'
    ShortDateTime = 5,      //  'dd mmm yyyy 1:45 PM''
    LongDateTime = 6,       //  'Monday, June 15, 2009 1:45:30 PM'
    Custom = 7
}